import React from "react";
import {
    AddTaskPrefill,
    RightDrawerOption,
} from "../fileToolbar/fileToolbarTypes";

export type RightSideContextValue = {
    rightSideBoolean: boolean;
    rightSideShow: string;
    account: string;
    toggleRightDrawer: (option: RightDrawerOption) => void;
    openNotesWithFilter: (filter?: string) => void;
    openTasksAddTask: (prefill: AddTaskPrefill) => void;
};

export const RightSideContext = React.createContext<RightSideContextValue>({
    rightSideBoolean: false,
    rightSideShow: "",
    account: "",
    toggleRightDrawer: () => undefined,
    openNotesWithFilter: () => undefined,
    openTasksAddTask: () => undefined,
});
